//@ts-nocheck

import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import Lottie from 'react-lottie';
import animationData from './../../assets/lotties/bcn.json';
const DropdownMenu = ({ active, menu }) => {
    if (active !== menu) return null;

    return (
        <div className="mt-4 w-full transition-all duration-300 md:block hidden">
            <Container>
                <div className="w-full xl:w-[960px] mx-auto p-6 rounded-[24px] bg-Mneutral900">
                    
                    {menu === "company" && (
                        <div className="w-full grid grid-cols-3 gap-3">
                            <CompanyLink href="/about-futeur" title="About" icon="iccs (1).svg" />
                            <CompanyLink href="/careers" title="Careers" icon="iccs (2).svg" />
                            <CompanyLink href="/legal" title="Legal" icon="iccs (3).svg" />
                            <CompanyLink href="/vision" title="Vision" icon="vision.svg" />
                            <CompanyLink href="/contact" title="Contact" icon="phone.svg" />
                        </div>
                    )}
                    {menu === "products" && (
                        <div className="w-full grid grid-cols-3 gap-3">
                            <CompanyLink href="/FuteurCred" title="FuteurCred" videoSrc="bcn.json" />
                        </div>
                    )}
                </div>
            </Container>
        </div>
    );
};

const FeatureLink = ({ href, title, icon, mockup }) => (
    <Link to={href} className="inline-block w-full MenuHover">
        <div className="w-full h-[210px] overflow-hidden rounded-[20px] relative transition-all duration-300 bg-Mneutral800 flex justify-center square one">
            <img src={`/images/${icon}`} className='absolute left-1/2 -translate-x-1/2 top-[60%] transition-all duration-500 -rotate-45 icon' alt="" />
            <img src={`/images/${mockup}`} className='self-end relative z-[1] transition-all duration-300 mockup' alt="" />
        </div>
        <div className="mt-4 flex items-center justify-between gap-2">
            <p className='font-medium text__18 text-white clamp-1'>{title}</p>
            <img src="/images/arrowWehite.svg" alt="" />
        </div>
    </Link>
);

const CompanyLink = ({ href, title, icon, videoSrc }) => (
    <Link
      to={href}
      className="flex items-center justify-between p-3 text-white border !border-Mneutral800 rounded-[20px]"
    >
      <div className="flex items-center gap-3">
        <div className="w-[100px] h-[100px] rounded-full bg-Mneutral800 flex items-center justify-center">
          {videoSrc ? (
            videoSrc.endsWith(".json") ? (
              <Lottie
                options={{
                  animationData: animationData,
                  autoplay: true,
                  loop: true,
                }}
                className="w-full h-full object-contain"
              />
            ) : videoSrc.endsWith(".gif") ? (
              <img
                src={`/videos/${videoSrc}`}
                alt={title}
                className="w-full h-full object-contain"
              />
            ) : (
              <video
                src={`/videos/${videoSrc}`}
                className="w-full h-full object-contain"
                autoPlay
                loop
                muted
              />
            )
          ) : (
            <img
              src={`/images/${icon}`}
              alt={title}
              className="w-full h-full object-contain"
            />
          )}
        </div>
        <p className="font-medium text__18">{title}</p>
      </div>
      <img src="/images/arrowWehite.svg" alt="Arrow Icon" />
    </Link>
  );
  
export default DropdownMenu;

